import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconBell';
/** Renders an SVG icon. */
const SvgBell = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13 7a4 4 0 0 0-4 4v9.5c0 1-.632 1.862-1.26 2.498-.346.35-.744.687-1.165 1.002h18.85c-.42-.315-.82-.652-1.165-1.002C23.632 22.362 23 21.5 23 20.5V11a4 4 0 0 0-4-4 1 1 0 1 1 0-2 6 6 0 0 1 6 6v9.5c0 .172.139.54.684 1.094.509.516 1.224 1.042 1.997 1.525.67.418.812 1.167.67 1.719-.143.557-.646 1.162-1.469 1.162H5.118c-.823 0-1.326-.605-1.469-1.162-.142-.552 0-1.3.67-1.719.773-.483 1.488-1.01 1.997-1.525C6.86 21.04 7 20.672 7 20.5V11a6 6 0 0 1 6-6zm-2.95 20.684a1 1 0 0 1 1.265-.633c1.958.651 3.34.947 4.685.947s2.726-.296 4.684-.947a1 1 0 0 1 .631 1.898c-2.042.679-3.66 1.048-5.315 1.048s-3.274-.37-5.316-1.048a1 1 0 0 1-.633-1.265Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 4c-.954 0-1.768.69-1.925 1.63l-.089.534a1 1 0 1 1-1.972-.328l.089-.534a3.951 3.951 0 0 1 7.794 0l.09.534a1 1 0 1 1-1.973.328l-.09-.534A1.95 1.95 0 0 0 16 4"
      />
    </svg>
  );
};
SvgBell.displayName = displayName;
export default SvgBell;
